module.exports = __webpack_public_path__ + "static/logo-blue-4fac17e2f7631135d9bd376124faa107.svg";